'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _Data = require('../../../../helpers/Data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The static/non-static styles Information for a single event dot on the timeline
 */
var dots = {
  /**
   * The style information for the clickable dates that apper floating over the timeline
   */
  links: {
    position: 'absolute',
    bottom: 0,
    textAlign: 'center',
    paddingBottom: 15
  },
  /**
   * The base style information for the event dot that appers exactly on the timeline
   */
  base: {
    position: 'absolute',
    bottom: -5,
    height: 12,
    width: 12,
    borderRadius: '50%',
    transition: 'background-color 0.3s, border-color 0.3s',
    ':hover': {} // We need this to track the hover state of this element
  },
  /**
   * future: The style information for the future dot (wrt selected).
   * @param {object} styles User passed styles ( foreground, background etc info
   */
  future: function future(styles) {
    return {
      backgroundColor: styles.background,
      // border: `2px solid ${styles.background}`,
      border: '2px solid ' + styles.outline
    };
  },
  /**
   * past: The styles information for the past dot (wrt selected)
   * @param {object} styles User passed styles ( foreground, background etc info
   */
  past: function past(styles) {
    return {
      backgroundColor: styles.background,
      border: '2px solid ' + styles.foreground
    };
  },
  /**
   * present: The styles information for the preset dot
   * @param {object} styles User passed styles ( foreground, background etc info
   */
  present: function present(styles) {
    return {
      backgroundColor: styles.foreground,
      border: '2px solid ' + styles.foreground
    };
  }
};

/**
 * The markup for one single dot on the timeline
  *
 * @param {object} props The props passed down
 * @return {StatelessFunctionalReactComponent} The markup for a dot
 */

var TimelineDot = function (_React$Component) {
  _inherits(TimelineDot, _React$Component);

  function TimelineDot() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimelineDot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimelineDot.__proto__ || Object.getPrototypeOf(TimelineDot)).call.apply(_ref, [this].concat(args))), _this), _this.__getDotStyles__ = function (dotType, key) {
      var hoverStyle = {
        backgroundColor: _this.props.styles.foreground,
        border: '2px solid ' + _this.props.styles.foreground
      };

      return [dots.base, { left: _this.props.labelWidth / 2 - dots.base.width / 2 }, dots[dotType](_this.props.styles), _radium2.default.getState(_this.state, key, ':hover') || _radium2.default.getState(_this.state, 'dot-dot', ':hover') ? hoverStyle : undefined];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimelineDot, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dotType = 'future';
      if (this.props.index < this.props.selected) {
        dotType = 'past';
      } else if (this.props.index === this.props.selected) {
        dotType = 'present';
      }

      var today = (0, _Data.formatLongToDate)(new Date());

      return _react2.default.createElement(
        'li',
        {
          key: this.props.date,
          id: 'timeline-dot-' + this.props.date,
          className: dotType + ' dot-label ' + ((0, _Data.formatLongToDate)(parseInt(this.props.date, 10)) === today && 'dot-label-today'),
          onClick: function onClick() {
            return _this2.props.onClick(_this2.props.index);
          },
          style: [dots.links, {
            left: this.props.distanceFromOrigin - this.props.labelWidth / 2,
            cursor: 'pointer',
            width: this.props.labelWidth,
            ':hover': {} // We need this to track the hover state of this element
          }]
        },
        _react2.default.createElement('div', { className: 'tl-titulo', dangerouslySetInnerHTML: { __html: this.props.label } }),
        _react2.default.createElement('span', {
          key: 'dot-dot',
          onClick: function onClick() {
            return _this2.props.onClick(_this2.props.index);
          },
          style: this.__getDotStyles__(dotType, this.props.date)
        })
      );
    }
  }]);

  return TimelineDot;
}(_react2.default.Component);

/**
 * propTypes
 * @type {Object}
 */


TimelineDot.propTypes = {
  // The index of the currently selected dot (required to style as old, present, or future event)
  selected: _propTypes2.default.number.isRequired,
  // The index of the present event (used for deciding the styles alongside selected)
  index: _propTypes2.default.number.isRequired,
  // The actual date of the event (used as key and id)
  date: _propTypes2.default.string.isRequired,
  // The onClick handler ( in this case to trigger the fillingMotion of the timeline )
  onClick: _propTypes2.default.func.isRequired,
  // The date of the event (required to display it)
  label: _propTypes2.default.string.isRequired,
  // The width you want the labels to be
  labelWidth: _propTypes2.default.number.isRequired,
  // The numerical value in pixels of the distance from the origin
  distanceFromOrigin: _propTypes2.default.number.isRequired,
  // The styles prefrences of the user
  styles: _propTypes2.default.object.isRequired
};

exports.default = (0, _radium2.default)(TimelineDot);


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/Components/TimelineDot.js
// module id = 1151
// module chunks = 0